import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary, RaikoCreatorInfo, RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn, RaikoSectionContainer, RaikoSimpleInputOutlined, RaikoToggleOutlined, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";

export default function MawakibServiceDetails() {

    const {id: mawakitServiceId = -1} = useParams()
    const {state} = useLocation()

    const [selectedValueTabMenu, setSelectedValueTabMenu] = useState(mawakibServiceTabType.BasicInformation.id)

    const service = new MawakibService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MawakibServiceList.name);


    const [serviceTitle, setServiceTitle] = useState("");
    const [enabled, setEnabled] = useState(true)
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");


    function handleChangeTabMenu(event, newValue) {
        setSelectedValueTabMenu(newValue)
    }

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getMawakibServiceDetailsFromServer()
        }
    }, [mawakitServiceId]);

    function getMawakibServiceDetailsFromServer() {
        loading.show()
        service.getMawakibServiceDetails(mawakitServiceId)
            .then(response => {
                setServiceTitle(response.title)
                setEnabled(response.enabled)
                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    const navigate = useNavigate()

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibManager.name,
                                RouteHelper.MawakibManager.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibServiceList.name,
                                RouteHelper.MawakibServiceList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            )
                        ]}
                    />
                    <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                        navigate(-1)
                    }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={selectedValueTabMenu}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={mawakibServiceTabType.BasicInformation.title}
                                value={mawakibServiceTabType.BasicInformation.id}
                            />
                        </TabList>

                    </Box>
                    <TabPanel value={mawakibServiceTabType.BasicInformation.id}>
                        <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                            <RaikoBaseCardContainer>
                                <RaikoSectionContainer
                                    title={mawakibServiceTabType.BasicInformation.title}
                                >
                                    <RaikoSimpleInputOutlined
                                        labelText={"عنوان"}
                                        value={serviceTitle}
                                        setValue={setServiceTitle}
                                    />
                                    <RaikoToggleOutlined
                                        checked={enabled}
                                        setChecked={setEnabled}
                                        labelText={"وضعیت"}
                                    />
                                </RaikoSectionContainer>
                            </RaikoBaseCardContainer>
                            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
                        </RaikoGridOneColumn>

                    </TabPanel>

                </TabContext>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
const mawakibServiceTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
}